import { render, staticRenderFns } from "./Dziennik.vue?vue&type=template&id=0ee6efda&scoped=true&"
import script from "./Dziennik.vue?vue&type=script&lang=js&"
export * from "./Dziennik.vue?vue&type=script&lang=js&"
import style0 from "./Dziennik.vue?vue&type=style&index=0&id=0ee6efda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee6efda",
  null
  
)

export default component.exports